var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdateContactInfoBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1317 562",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#edeefc;}.cls-2{fill:#0d37c9;}.cls-3{fill:#dcdcf5;}.cls-4{fill:none;stroke:#c5c9f6;stroke-linecap:round;stroke-linejoin:round;stroke-width:9px;}.cls-5{fill:#c5c9f6;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Surface-2",
    className: "cls-1",
    x: 19.32,
    y: 134.6,
    width: 1280,
    height: 423,
    rx: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1171",
    "data-name": "Group 1171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    "data-name": "Group 1110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    className: "cls-2",
    d: "M316.47,207a51,51,0,0,1-.22-7.31l3.37.46a49.8,49.8,0,0,0,.2,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    className: "cls-2",
    d: "M321.83,185.81l-3.26-1.2a105.79,105.79,0,0,1,4.72-14.08l3.12,1.65A103.9,103.9,0,0,0,321.83,185.81Zm10.73-26.52-3-2c2.24-4.14,4.75-8.31,7.47-12.4l2.83,2.2c-2.67,4-5.13,8.1-7.33,12.16Zm15.61-23.59-2.68-2.4c2.95-3.74,6.08-7.39,9.29-10.86L357.3,125c-3.16,3.41-6.23,7-9.13,10.68Zm19.06-20.55-2.35-2.76c3.57-3.27,7.23-6.33,10.9-9.11l2.14,2.93c-3.59,2.73-7.19,5.73-10.69,8.94Zm22.16-16.77-1.88-3.1a108.78,108.78,0,0,1,12.62-6.59L401.67,92a106.89,106.89,0,0,0-12.28,6.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "cls-2",
    d: "M414.72,87.47,413.64,84c2.24-.57,4.47-1,6.62-1.35l.79,3.5C419,86.49,416.86,86.93,414.72,87.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    className: "cls-2",
    d: "M997.26,146c.39-2.34.69-4.67.89-6.9l3.28.54c-.2,2.33-.52,4.77-.93,7.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    className: "cls-2",
    d: "M901.62,255l-.87-3.52a119.48,119.48,0,0,0,11.7-3.42l1.16,3.44A122.61,122.61,0,0,1,901.62,255Zm23.56-8.24-1.45-3.33a117.78,117.78,0,0,0,10.79-5.79l1.72,3.18a124.72,124.72,0,0,1-11,5.93Zm21.49-13-2-3c3.27-2.46,6.48-5.12,9.53-7.91l2.2,2.81c-3.12,2.86-6.41,5.59-9.76,8.1Zm18.77-17.15L963,214c2.79-3.07,5.5-6.33,8-9.68l2.59,2.39c-2.6,3.43-5.37,6.76-8.23,9.91ZM981,196.07l-2.75-2.15c2.27-3.61,4.4-7.36,6.34-11.13l2.9,1.89c-2,3.86-4.16,7.69-6.48,11.39Zm12-23.42L990,171c1.65-4.1,3.09-8.23,4.28-12.3l3.15,1.27c-1.22,4.18-2.71,8.43-4.4,12.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    className: "cls-2",
    d: "M882.66,258l-.42-3.6c2.18-.16,4.33-.39,6.45-.66l.57,3.57C887.09,257.57,884.88,257.8,882.66,258Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    className: "cls-2",
    d: "M605.18,34.79c-2.27.3-4.52.67-6.68,1.13l-1.07-3.3c2.25-.48,4.59-.87,7-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    className: "cls-2",
    d: "M774,138.45l-3.23,1.07q-1.23-2.78-2.67-5.56c-1.24-2.4-2.59-4.85-4-7.25l3-1.46c1.48,2.48,2.87,5,4.14,7.46C772.21,134.63,773.13,136.55,774,138.45Zm-18-23.93c-2.83-3.86-5.93-7.74-9.21-11.53l2.63-2c3.36,3.87,6.52,7.84,9.41,11.77Zm-19.33-22.4c-3.48-3.49-7.14-6.92-10.88-10.2L728,79.53c3.81,3.34,7.54,6.84,11.08,10.38ZM714.16,72.44c-4-3-8.06-6-12.18-8.72L703.82,61c4.19,2.8,8.35,5.78,12.39,8.88ZM689.25,55.85c-4.36-2.49-8.81-4.83-13.23-6.94l1.33-3c4.51,2.15,9,4.53,13.5,7.07ZM662.32,43.06c-4.72-1.78-9.46-3.32-14.09-4.58l.66-3.24c4.76,1.29,9.61,2.87,14.45,4.7ZM633.87,35.4a109.15,109.15,0,0,0-14.44-1.32l-.24-3.38a116.67,116.67,0,0,1,14.93,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    className: "cls-2",
    d: "M780.49,159.22l-3.49.23c-.36-2.14-.84-4.34-1.43-6.54l3.42-.54C779.61,154.68,780.11,157,780.49,159.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1124",
    "data-name": "Group 1124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_account_balance_wallet_24px",
    "data-name": "ic account balance wallet 24px",
    className: "cls-3",
    d: "M1077.4,109v4.47a9,9,0,0,1-8.94,9h-62.62a9,9,0,0,1-8.94-9h0V50.85a8.93,8.93,0,0,1,8.94-8.94h62.62a9,9,0,0,1,8.94,8.94v4.48h-40.25a8.94,8.94,0,0,0-8.94,8.94v35.78a9,9,0,0,0,8.94,9h40.25Zm-40.25-9h44.73V64.27h-44.73ZM1055,88.87a6.71,6.71,0,1,1,6.71-6.71h0a6.7,6.7,0,0,1-6.71,6.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_insert_drive_file_24px",
    "data-name": "ic insert drive file 24px",
    className: "cls-3",
    d: "M464.68,19.68a10,10,0,0,0-9.95,10l-.05,80.13a10,10,0,0,0,10,10h60.14a10,10,0,0,0,10-10V49.72l-30-30Zm35,35.05V27.19l27.55,27.54Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-file-text",
    "data-name": "Icon feather-file-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    className: "cls-4",
    d: "M819.13,206H780.62a9.42,9.42,0,0,0-9.63,9.19V288.7a9.43,9.43,0,0,0,9.63,9.2h57.77a9.43,9.43,0,0,0,9.63-9.2h0V233.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    className: "cls-4",
    d: "M819.14,206v27.58H848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    className: "cls-4",
    d: "M828.76,256.52H790.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    className: "cls-4",
    d: "M828.76,274.91H790.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    className: "cls-4",
    d: "M799.88,238.14h-9.63"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ic_insert_drive_file_24px-2",
    "data-name": "ic insert drive file 24px-2",
    className: "cls-2",
    d: "M475.38,5.09a10,10,0,0,0-9.94,10l-.06,80.13a10,10,0,0,0,10,10h60.13a10,10,0,0,0,10-10V35.13l-30-30Zm35.05,35.05V12.6L538,40.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    className: "cls-5",
    d: "M277.24,206C265,206,255,216.21,255,228.86s10,22.9,22.22,22.9,22.21-10.25,22.21-22.9S289.51,206,277.24,206Zm0,51.53c-14.83,0-44.43,7.67-44.43,22.9v17.17h88.86V280.39c0-15.23-29.6-22.9-44.43-22.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_account_balance_wallet_24px-2",
    "data-name": "ic account balance wallet 24px-2",
    className: "cls-2",
    d: "M1080.78,104.22v4.44a8.9,8.9,0,0,1-8.89,8.89h-62.21a8.89,8.89,0,0,1-8.89-8.89h0V46.44a8.89,8.89,0,0,1,8.88-8.88h62.22a8.9,8.9,0,0,1,8.89,8.88v4.45h-40a8.89,8.89,0,0,0-8.89,8.89V95.33a8.89,8.89,0,0,0,8.89,8.89h40Zm-40-8.89h44.44V59.78h-44.44Zm17.78-11.11a6.67,6.67,0,1,1,6.66-6.67h0a6.67,6.67,0,0,1-6.66,6.67Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateContactInfoBanner);
export default __webpack_public_path__ + "static/media/update-contact-info-banner.08d8d42405c62d24331d5024961fd9a0.svg";
export { ForwardRef as ReactComponent };